window.fetchCrateDetails = async function(nonce) {
    const apiUrl = '/wp-json/birnn/v1/crate-packing-details';
    try {
      const response = await fetch(apiUrl, {
        credentials: 'same-origin',
        headers: {
          'X-WP-Nonce': nonce,
        },
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.statusText}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Error fetching crate details:', error);
      return null;
    }
  }
